import { render, staticRenderFns } from "./Step4.vue?vue&type=template&id=01882084&scoped=true"
import script from "./Step4.vue?vue&type=script&lang=js"
export * from "./Step4.vue?vue&type=script&lang=js"
import style0 from "./Step4.vue?vue&type=style&index=0&id=01882084&prod&scoped=true&lang=scss"
import style1 from "./Step4.vue?vue&type=style&index=1&id=01882084&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01882084",
  null
  
)

export default component.exports